import {IntermediatePart} from "../../intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class ShowerPanCombo extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_pan_combo';
    this.partName = 'Shower Pan';
    this.translateId = "visualizer.bathroom.shower.shower_pan_combo";
    this.dbName = "Shower Pans";  // americanstandard2020 // lowesdemo // bucket5
    this.visible = true;
    this.isStoneFeature = false;
    this.layerPriority = 8;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.load_(dbFeature, new ShowerPanCombo())
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = false;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked); // set active item & not in visualizer item
    this.applyFeatureIfNotCompatible();
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  setLayers(layout) {

    const showerParent = this.getParent();

    if (showerParent.showerTubComboIsActive() || showerParent.showerFloorIsActive) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && !this.activeFeature.notAvailableInVisualizer
      && this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.ShowerPanCombo;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
  }

  getMatchingPositionFeature(position = "", forFeature = this.activeFeature) {
    if (forFeature) { //just in case
      let arrayOfConditions = this.getArrayOfConditions();
      if (forFeature.metaData["SkuName"]) {
        arrayOfConditions.push({
          propName: "SkuName",
          propValue: forFeature.metaData["SkuName"]
        })
      }
      return this.features.find((feature) => {
        return feature.matchesMetaForArrayOfConditions(arrayOfConditions) && feature.metaData["layerPosition"] === position
      });
    }
    return null
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }

}
